// extracted by mini-css-extract-plugin
export default {"searchContainer":"BackgroundWatch_searchContainer__pxqGP","paginationContainer":"BackgroundWatch_paginationContainer__1aDu+"};